import { gql } from '@apollo/client';

export const ALL_USER_NOTIFICATIONS = gql`
  query AllUserNotifications($skip: Int!, $take: Int!, $where: NotificationFilterInput!) {
    allUserNotifications(
      skip: $skip
      take: $take
      where: $where
      order: { createdAt: DESC }
    ) {
      items {
        correlationId
        code
        wasDisplayed
        isHidden
        createdAt
        params {
          name
          value
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

export const USER_NOTIFICATION = gql`
  query UserNotification($correlationId: UUID!) {
    userNotification(where: { correlationId: { eq: $correlationId } }) {
      correlationId
      code
      wasDisplayed
      isHidden
      createdAt
      params {
        name
        value
      }
    }
  }
`;
